
import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/Login'
import MenuView from '@/layouts/MenuView'
import RouteView from '@/layouts/RouteView'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: '登录页',
      component: Login,
      invisible: true
    },
    {
      path: '/',
      name: '后台管理',
      component: MenuView,
      icon: 'none',
      children: [
        {
          path: '/work',
          name: '工作台',
          icon: 'desktop',
          component: () => import('@/pages/Work')
        },
        {
          path: '/repair',
          name: '报修管理',
          icon: 'edit',
          component: () => import('@/pages/Repair/index')
        },
        {
          path: '/wjRepairManage',
          name: '报修管理',
          icon: 'edit',
          component: () => import('@/pages/WjRepair/index')
        },
        {
          path: '/myrepair',
          name: '我要报修',
          icon: 'tool',
          component: () => import('@/pages/Repair/myRepair')
        },
        {
          path: '/statistics',
          name: '统计分析',
          component: RouteView,
          icon: 'form',
          children: [
            {
              path: '/order',
              name: '报修单统计',
              icon: 'none',
              component: () => import('@/pages/Order')
            },
            {
              path: '/ItOrder',
              name: '报修单统计',
              icon: 'none',
              component: () => import('@/pages/ItOrder')
            },
            {
              path: '/praise',
              name: '评价统计',
              icon: 'none',
              component: () => import('@/pages/Praise')
            },
            {
              path: '/consumables',
              name: '耗材统计',
              icon: 'none',
              component: () => import('@/pages/Consumables')
            },
            {
              path: '/wjConsumables',
              name: '皖江耗材统计',
              icon: 'none',
              component: () => import('@/pages/WjConsumables')
            }
          ]
        },
        {
          path: '/yearStatistics',
          name: '年度统计',
          icon: 'none',
          component: () => import('@/pages/Statistics')
        },
        {
          path: '/noticeManagement',
          name: '标识管理',
          icon: 'none',
          component: () => import('@/pages/Noticemanagement')
        },
        {
          path: '/system',
          name: '系统设置',
          component: RouteView,
          icon: 'warning',
          children: [
            {
              path: '/parameter',
              name: '参数设置',
              icon: 'none',
              component: () => import('@/pages/Parameter')
            },
            {
              path: '/notice',
              name: '报修须知',
              icon: 'none',
              component: () => import('@/pages/Notice')
            },
            {
              path: '/pmanagement',
              name: '人员管理',
              icon: 'none',
              component: () => import('@/pages/Pmanagement')
            },
            {
              path: '/gysmanagement',
              name: '供应商管理',
              icon: 'none',
              component: () => import('@/pages/gysmanagement/index')
            },
            {
              path: '/gysmanagement/detail',
              name: '供应商详情',
              icon: 'none',
              invisible: true,
              component: () => import('@/pages/gysmanagement/detail')
            },
            {
              path: '/gysmanagement/add',
              name: '新增供应商',
              icon: 'none',
              invisible: true,
              component: () => import('@/pages/gysmanagement/add')
            }
          ]
        },
        {
          path: '/minorWorks',
          name: '零星工程管理',
          icon: 'none',
          component: () => import('@/pages/lxgcmanagement/index')
        },
        {
          path: '/minorWorks/add',
          name: '新增零星工程',
          icon: 'none',
          invisible: true,
          meta: { parentName: '零星工程管理', parentPath: '/minorWorks' },
          component: () => import('@/pages/lxgcmanagement/add')
        },
        {
          path: '/minorWorks/detail',
          name: '详情',
          icon: 'none',
          invisible: true,
          meta: { parentName: '零星工程管理', parentPath: '/minorWorks' },
          component: () => import('@/pages/lxgcmanagement/detail')
        },
        {
          path: '/minorWorks/quoteApproval',
          name: '报价审批',
          icon: 'none',
          invisible: true,
          meta: { parentName: '零星工程管理', parentPath: '/minorWorks' },
          component: () => import('@/pages/lxgcmanagement/quoteApproval')
        },
        {
          path: '/minorWorks/changeApproval',
          name: '变更审批',
          icon: 'none',
          invisible: true,
          meta: { parentName: '零星工程管理', parentPath: '/minorWorks' },
          component: () => import('@/pages/lxgcmanagement/changeApproval')
        },
        {
          path: '/minorWorks/acceptApproval',
          name: '验收审批',
          icon: 'none',
          invisible: true,
          meta: { parentName: '零星工程管理', parentPath: '/minorWorks' },
          component: () => import('@/pages/lxgcmanagement/acceptApproval')
        }
      ]
    },
    {
      path: '/apply',
      name: '报修申请',
      icon: 'none',
      component: () => import('@/pages/Apply')
    },
    {
      path: '/myApply',
      name: '我的报修',
      icon: 'none',
      component: () => import('@/pages/Apply/myApply')
    },
    {
      path: '/wjRepair',
      name: '我要报修',
      icon: 'none',
      component: () => import('@/pages/WjRepair/wjRepair')
    },
    // 异常页面
    {
      path: '*',
      component: () => import('@/components/exception/404.vue')
    },
    {
      path: '/403',
      component: () => import('@/components/exception/403.vue')
    }
  ],
  // 路由切换时，页面滚动到顶部
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})
